/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import React from "react";
import { ICON_SIZE_STANDARD, ICON_SIZE_LARGE } from "../../constants";
import * as Classes from "../../classes";
export var CaretRight = function (_a) {
    var className = _a.className, color = _a.color, _b = _a.size, size = _b === void 0 ? ICON_SIZE_STANDARD : _b, _c = _a.title, title = _c === void 0 ? "caret-right" : _c, _d = _a.htmlTitle, htmlTitle = _d === void 0 ? title : _d, _e = _a.tagName, tagName = _e === void 0 ? "span" : _e, htmlProps = __rest(_a, ["className", "color", "size", "title", "htmlTitle", "tagName"]);
    var isLarge = size >= ICON_SIZE_LARGE;
    var pixelGridSize = isLarge ? ICON_SIZE_LARGE : ICON_SIZE_STANDARD;
    var viewBox = "0 0 " + pixelGridSize + " " + pixelGridSize;
    var path = (React.createElement("path", { d: isLarge
            ? "M14 10C14 10.31 13.85 10.57 13.63 10.76L13.64 10.77L7.64 15.77L7.63 15.76C7.46 15.9 7.24 16 7 16C6.45 16 6 15.55 6 15V5C6 4.45 6.45 4 7 4C7.24 4 7.46 4.1 7.63 4.24L7.64 4.23L13.64 9.23L13.63 9.24C13.85 9.43 14 9.69 14 10z"
            : "M11 8C11 8.15 10.93 8.28 10.83 8.37L10.83 8.37L6.83 11.87L6.83 11.87C6.74 11.95 6.63 12 6.5 12C6.22 12 6 11.78 6 11.5V4.5C6 4.22 6.22 4 6.5 4C6.63 4 6.74 4.05 6.83 4.13C6.83 4.13 6.83 4.13 6.83 4.13L10.83 7.63L10.83 7.63C10.93 7.72 11 7.85 11 8z", fillRule: "evenodd" }));
    if (tagName === null) {
        return (React.createElement("svg", __assign({ fill: color, "data-icon": "caret-right", width: size, height: size, viewBox: viewBox }, htmlProps),
            title && React.createElement("desc", null, title),
            path));
    }
    else {
        return React.createElement(tagName, __assign(__assign({}, htmlProps), { className: className + " " + Classes.ICON, title: htmlTitle }), React.createElement("svg", { fill: color, "data-icon": "caret-right", width: size, height: size, viewBox: viewBox },
            title && React.createElement("desc", null, title),
            path));
    }
};
export default CaretRight;
//# sourceMappingURL=caret-right.js.map